import React from 'react';
import { ALLOW_FONT_SCALING } from './constants';
const Text = __NATIVE__ ? require('react-native').Text : null;

function Space() {
  return __NATIVE__ ? (
    <Text allowFontScaling={ALLOW_FONT_SCALING}> </Text>
  ) : (
    <span>&nbsp;</span>
  );
}

Space.displayName = 'Space';
export default Space;
